export const SearchTypes = {
  Index: 162,
  FullText: 161,
}
